import {createActions, createReducer} from 'reduxsauce'
import { Action } from 'redux'
import {ReducerTypes} from "./utils";

// Define reducer types
type ActionTypes = {
    SET_ALLOW_CLOSE: string
    SET_SERVICE_CARD_INFO: string
}

// Define action types and creators
const actions = {
    setAllowClose: ['allowClose'],
    setServiceCardInfo: ['serviceCardToken', 'serviceCardIsNew', 'serviceCardIsProvisional'],
}

type AnyCreators = {
    [key in keyof typeof actions]: (...params: any[]) => Action<any>
}

// Override AnyCreators with strong types
interface Creators extends AnyCreators {
    allowClose: (allowClose: boolean) => Action<any>
    setServiceCardInfo: (serviceCardToken?: string, serviceCardIsNew?: boolean, serviceCardIsProvisional?: boolean) => Action<any>,
}

const { Types, Creators } = createActions<ActionTypes, Creators>(actions)

export const SelfServiceTypes = Types
export default Creators

// Define initial state
export interface SelfServiceState {
    allowClose?: boolean
    serviceCardToken?: string
    serviceCardIsNew?: boolean
    serviceCardIsProvisional?: boolean
}

export const INITIAL_STATE: SelfServiceState = {
    allowClose: true,
}

// Define reducers
const setAllowClose = (state: SelfServiceState, { allowClose }: SelfServiceState) => ({
    ...state,
    allowClose,
})

const setServiceCardInfo = (state: SelfServiceState, { serviceCardToken, serviceCardIsNew, serviceCardIsProvisional }) => ({
    ...state,
    serviceCardToken,
    serviceCardIsNew,
    serviceCardIsProvisional,
})

type SelfServiceTypes = ReducerTypes<SelfServiceState, ActionTypes>

export const reducerTypes = {
    [Types.SET_ALLOW_CLOSE]: setAllowClose,
    [Types.SET_SERVICE_CARD_INFO]: setServiceCardInfo,
}

export const reducer = createReducer<SelfServiceState, Action<SelfServiceTypes>>(
    INITIAL_STATE,
    reducerTypes,
)
